<template>
    <div>
        <!-- Modal Consumos -->
        <div class="modal fade" id="consumoConsumosPacienteModal" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
            <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Consumos do Paciente</h5>
                            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                                <span aria-hidden="true">&times;</span>
                            </button>
                    </div>
                    <div class="modal-body">
                        <az-loading v-if="!dados && $store.state.loading"></az-loading>

                        <div v-else-if="dados && dados.marcacao">
                            <div class="alert alert-info d-flex justify-content-between">
                                <div>
                                    {{ dados.marcacao.nome_paciente }}
                                    <div v-if="dados.marcacao.id_atendimento">#{{ dados.marcacao.id_atendimento }}</div>
                                    <div class="small text-muted" v-if="dados.marcacao.procedimento">
                                        {{ dados.marcacao.procedimento.search }}
                                    </div>
                                </div>
                                <div class="text-right">
                                    <div>{{ $util.getFormatDate(dados.marcacao.dt_inicio) }}</div>
                                    <div class="small text-muted">M{{ dados.marcacao.id_marcacao }}</div>
                                </div>
                            </div>
                        </div>

                        <enfermagem-consumo-mat-med 
                            v-if="dados && dados.marcacao" 
                            :notitle="true"
                            :atendimento="dados"></enfermagem-consumo-mat-med>

                        <pre v-if="false">{{ dados }}</pre>
                    </div>
                    <div class="modal-footer">
                        <button type="button" class="btn btn-secondary" data-dismiss="modal">Fechar</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from 'jquery';
import AzLoading from '../../util/AzLoading.vue';
import EnfermagemConsumoMatMed from '../enfermagem/EnfermagemConsumoMatMed.vue';

export default {
    data() {
        return {
            dados: null
        }
    },

    components: { 
        AzLoading,
        EnfermagemConsumoMatMed,
    },
  
    methods: { 
        abrir (id_marcacao) { 

            this.dados = null; 

            this.$util.load(this, { 
                service: 'estoque',
                func: 'consultar_consumos_paciente', 
                parms: { 
                    id_marcacao: id_marcacao
                },
                loadTo: res => { 
                    this.dados = res.atendimento;
                }
            })

            $('#consumoConsumosPacienteModal').modal('show');

        }

    }

}
</script>
